import axiosConfig from "./axiosConfig";

// "completed" and "timeout" both carry whatever the agent wrote as
// reportMarkdown (partial output in the timeout case); "no_answer" is a run
// that produced no text at all. "failed" only appears in the LRO result (an
// AI-model configuration problem) - failed runs are never persisted as
// investigation rows.
export type HealthInvestigationStatus =
  | "completed"
  | "timeout"
  | "no_answer"
  | "failed";

// One turn of an investigation. Runs sharing a `sessionId` form a thread
// (question -> answer -> follow-up question -> answer); `parentRunId` is the
// turn this one continues. `question` is the operator's focus / follow-up text
// for this turn - null for an initial run started with no focus. The answer is
// `reportMarkdown`, with `headline` its first line (a standalone one-sentence
// answer).
export interface HealthInvestigation {
  runId: string;
  sessionId: string;
  parentRunId: string | null;
  createdAt: string;
  createdBy: string | null;
  question: string | null;
  status: HealthInvestigationStatus;
  headline: string | null;
  reportMarkdown: string | null;
  modelId: string | null;
  usage: Record<string, number> | null;
  costUsd: number | null;
  traceRunId: string | null;
}

export interface SiteHealthInvestigationsResponse {
  investigations: HealthInvestigation[];
  // The run in flight for this site, if any, so a page can adopt one it didn't start.
  activeOperationKey: string | null;
}

const getSiteHealthInvestigations = async (
  authToken: string,
  siteId: string
): Promise<SiteHealthInvestigationsResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/health/investigations`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default getSiteHealthInvestigations;
